// Momentum — the Momentum-specific part of the Read: its six examples, copy and
// settings, gathered in MOMENTUM for the shared Read (sequence/SequenceRead).
// The flow, the chart, the player, the answer type and the evidence spotlight
// are shared Edge code (sequence/, core/).
//
// The examples are QUSHi's approved lesson data, kept exactly as supplied
// (momentumExamples.json): prices keep their full precision; only the display
// rounds them.
import { moveDirection } from "../../sequence/sequenceModel";
import EXAMPLES from "./momentumExamples.json";

export { EXAMPLES };

export const READ = {
  revealMs: 700, // time between candles while the sequence builds
  dividerAfter: 4, // the neutral divider sits between candles 4 and 5
  // On this device only (client): the Call It order for the current attempt,
  // so it holds if the learner resumes in the same browser. Cleared when the
  // Read completes; a different browser or cleared storage starts fresh.
  orderStorageKey: "edge.momentum.callItOrder",
  // TEMPORARY (staged review): the full flow runs, but the primary button on
  // the last screen does nothing, so the completion screen is held back. Set
  // to false to restore it.
  holdCompletion: false,
};

// PLACEHOLDER reward values, as Candle Anatomy. Display only: nothing is
// credited to the wallet.
export const REWARDS = { completion: 50, firstAttemptBonus: 25 };

export const ANSWERS = [
  { id: "strengthening", label: "Strengthening" },
  { id: "weakening", label: "Weakening" },
];

export const COPY = {
  title: "Momentum",
  // Shared Call It / Retry prompt (QUSHi handoff README), two paragraphs (client).
  prompt: ["Compare the earlier three candles with the later three.", "Is momentum in this move strengthening or weakening?"],
  historical: "Real historical example",
  teachName: { strengthening: "Strengthening momentum", weakening: "Weakening momentum" },
  correct: "Correct",
  incorrect: "Not quite",
  // The actual read, e.g. "Downward momentum is weakening." (client).
  read: (direction, answer) => `${direction === "up" ? "Upward" : "Downward"} momentum is ${answer}.`,
  yourAnswer: "Your answer",
};

// Everything the shared Read needs (sequence/SequenceRead, SequenceStep).
export const MOMENTUM = {
  ...READ,
  title: COPY.title,
  examples: EXAMPLES,
  rewards: REWARDS,
  teachOrder: ["strengthening", "weakening"],
  answers: () => ANSWERS.map((a) => a.id),
  options: () => ANSWERS,
  prompt: () => COPY.prompt,
  heading: (ex) => COPY.teachName[ex.answer],
  readLine: (ex) => COPY.read(moveDirection(ex), ex.answer),
  copy: COPY,
};
